/* eslint-disable */
!function ($) {

	// Only add this jQuery plugin once
	if ($.fn.mktablefloat) { return; }

	/*****************

	TableFloat

	*****************/

	function TableFloat($container, options /* placeholder - currently there are no options */) {
		this.$container = $($container);
		this.type = this.$container.hasClass('table-responsive') //bootstrap class for horizontal scroll
			? this.TYPE.COLUMN
			: this.TYPE.HEADER;

		//the THeadFloat and TColumnFloat behaviors have been
		//seperated into different objects so it's easier to read, update, and debug

		if (this.type == this.TYPE.HEADER) {
			this.ui = new THeadFloat(this.$container, options);
		} else {
			this.ui = new TColumnFloat(this.$container, options);
		}
	}

	TableFloat.prototype = {

		ui: null,

		TYPE: {
			COLUMN: 1,
			HEADER: 2
		}
	};


	/*****************

	End TableFloat

	*****************/

	/*****************

	THeadFloat

	*****************/

	function THeadFloat($container, options) {
		//our base container.
		//This is not the actual table.
		this.$container = $container;
		//The table we want floating headers on
		this.$table = this.$container.find('table');
		//Query for a fixed site navigation to take into account
		this.fixedNav = $('> .affix', document.body);
		//currently no options available
		this.options = $.extend({}, options || {});
		//Props to be set for a .css() call later
		this.props = {};
		//We're keeping track of all instances so we can eliminate
		//multiple scroll and resize events.
		THeadFloat.instances.add(this);
	}

	THeadFloat.instances = {

		//instance cache
		_: [],

		//bool for binding only a single event
		watching: false,

		add: function (instance) {
			//add an instance only if it's a THeadFloat
			if (instance instanceof THeadFloat) {
				this._.push(instance);
				this.watch();
			}
		},

		watch: function () {
			//bind only once per page.. MAJOR EFFICIENT!!!
			if (!this.watching) {

				var self = this;

				$(window)
				.on('resize.tablefloat', function () {
					//loop instances and call resize
					jQuery.each(self._, function () {
						this.resize();
					});
				})
				.on('scroll.tablefloat', function () {
					//loop instances and call scroll
					jQuery.each(self._, function () {
						this.scroll();
					});
				});
				//bind only once
				this.watching = true;
			}
		}
	};

	THeadFloat.prototype = {

		buildHeader: function () {
			//create a clone
			var $clone = this.$table.clone();
			//create a wrapper for our clone.
			//divs are easier to manipulate than table elements
			var $wrapper = $('<div class="table-floater" />');
			//remove the bulk - we only want the header
			$clone.find('tbody').remove();
			//append the clone to our wrapper
			$wrapper.append($clone);
			//hide the wrapper until triggered
			$wrapper.hide();
			//append and set element hooks
			this.$container.append($wrapper);
			this.$header = $wrapper;

			this.sizeCells();
			this.bindSortEvents();
		},

		bindSortEvents: function () {

			var $thgroup = this.$header.find('thead tr:last th'),
				$originalThGroup = this.$table.find('thead tr:last th');

			//add delegate to trigger original TH click event
			//and do stuff with it..
			$thgroup.on('click', function (e) {

				var $th = $(this),
					index = $th.index(),
					originalTh = $originalThGroup[index];

				$(originalTh).trigger('click');

				setTimeout(function () {
					$thgroup.removeClass('tablesorter-headerAsc tablesorter-headerDesc');
					$th[0].className = originalTh.className;
				}, 0);
			});
		},

		sizeCells: function () {
			//grab the first row of cells in a data tbody (some tbodys are category labels)
			var $cells = this.$table.find('tbody:last tr:first > *'),
				//grab our floating header cells (can be a mix of th and td)
				$floatcells = this.$header.find('thead tr:last > *');

			//loop our set of cells to apply the correct widths
			//so our rows are flush and flowing
			$floatcells.each(function (i) {
				$(this).width($($cells[i]).width());
			});
		},

		scroll: function () {
			var $w = $(window),
				//get the offset of the fixed nav if we have one. default is 0.
				offsetTop = this.fixedNav.length && this.fixedNav.height() || 0,
				//get our offset for our container.
				//this gives us the correct left and top position relevant to the page
				offsets = this.$container.offset(),
				//actual scroll top
				scroll = $w.scrollTop() + offsetTop,
				//max number before the table is out of view
				limit = (offsets.top + this.$table.height()) - this.$table.find('thead').height();

			if (this.fixedNav.length === 0 && offsetTop === 0) {
				// check to see if there is an affixed header, which will accommodate the company page
				this.fixedNav = $('.affix', document.body);
			}

			//if we arent already floating and meet the requirements..
			if (offsets.top < scroll && limit > scroll) {

				if (!this.$header) {
					this.buildHeader();
				}

				this.props.width = this.$table.width();
				this.props.left = offsets.left;
				this.props.top = offsetTop;

				this.$header.css(this.props);
				this.$header.show();
			}
				//if we are currently floating but scroll up to where it's not needed
				//OR if we scroll too far down..
			else if (offsets.top > scroll || limit < scroll) {
				if (this.$header) {
					this.$header.remove();
					this.$header = null;
				}
			}
		},

		resize: function () {
			if (this.$header) {
				this.sizeCells();
				this.scroll();
			}
		}
	};

	/*****************

	End THeadFloat

	*****************/

	/*****************

	TColumnFloat

	*****************/

	function TColumnFloat($container, options) {
		//our base container.
		//This is not the actual table.
		this.$container = $($container);
		//The table we want floating headers on
		this.$table = this.$container.find('table');
		//currently no options available
		this.options = $.extend({}, options || {});
		//Props to be set for a .css() call later
		this.props = {};

		//build column..
		this.buildColumn();
		//bind scroll event to container..
		this.bind();

		this.rebuildColumn = this.rebuildColumn;

		//set global window event..
		TColumnFloat.instances.add(this);
	}

	TColumnFloat.instances = {

		//instance cache
		_: [],

		//bool for binding only a single event
		watching: false,

		add: function (instance) {
			//add an instance only if it's a THeadFloat
			if (instance instanceof TColumnFloat) {
				this._.push(instance);
				this.watch();
			}
		},

		watch: function () {
			//bind only once per page.. MAJOR EFFICIENT!!!
			if (!this.watching) {

				var self = this;

				$(window)
				.on('resize.tablefloat', function () {
					//loop instances and call resize
					jQuery.each(self._, function () {
						this.resize();
					});
				})
				//bind only once
				this.watching = true;
			}
		}
	};

	TColumnFloat.prototype = {

		bind: function () {
			this.$container
				.on('scroll.tablefloat', $.proxy(this.scroll, this));

		},

		scroll: function (e) {
			//grab the left position to see if we've scrolled//
			var left = this.$container.scrollLeft();

			if (left > 0) {
				//show float column if hidden
				if (this.$column.is(':hidden')) {
					this.$column.show();
				}
				//set the left property so we're always in view
				this.$column.css('left', left);
				return;
			}
			this.$column.hide();
		},

		buildColumn: function () {
			//create a clone
			var $clone = this.$table.clone();
			//create a wrapper for our clone.
			//divs are easier to manipulate than table elements
			var $wrapper = $('<div class="table-floater" />');
			//remove all node but first column
			$clone.find('thead tr:last th:not(:first)').remove();
			$clone.find('tbody tr').each(function () {
				$(this).find('> td:not(:first)').remove();
			});
			//append the clone to our wrapper
			$wrapper.append($clone);
			//hide the wrapper until triggered
			$wrapper.hide();
			//append and set element hooks
			this.$container.append($wrapper);
			this.$column = $wrapper;

			this.sizeCells();
			this.bindSortEvents();
		},

		rebuildColumn: function() {
			//create a clone
			var $clone = this.$table.clone();

			//get the first column of each row
			$clone.find('thead tr:last th:not(:first)').remove();
			var $Tbody = $clone.find('tbody tr').each(function () {
				$(this).find('> td:not(:first)').remove();
			});

			//replace the existing float table rows
			this.$column.find('table').html($clone.html());
		},

		bindSortEvents: function () {

			var $thgroup = this.$column.find('thead tr:last th'),
				$originalThGroup = this.$table.find('thead tr:last th');

			//add delegate to trigger original TH click event
			//and do stuff with it..
			$thgroup.on('click', function (e) {

				var $th = $(this),
					index = $th.index(),
					originalTh = $originalThGroup[index];

				$(originalTh).trigger('click');

				setTimeout(function () {
					$thgroup.removeClass('tablesorter-headerAsc tablesorter-headerDesc');
					$th[0].className = originalTh.className;
				}, 0);
			});
		},

		sizeCells: function () {
			//grab rows in original table
			var $rows = this.$table.find('tbody tr'),
				//grab rows in the float column
				$floatrows = this.$column.find('tbody tr');

			//loops float rows and set the height to match the 
			//first table cell in the original table. This is important 
			//in case cells wrap multiple lines, etc.
			$floatrows.each(function (i) {
				$(this).find('td').height($($rows[i]).find('td:first').height());
			});

			//we can set width on the table rather than each cell..
			this.$column.width($rows.filter(':first').find('td:first').outerWidth());
		},

		resize: function () {
			if (this.$column) {
				this.sizeCells();
				this.scroll();
			}
		}
	};

	/*****************

	End TColumnFloat

	*****************/

	/*****************

	Add to jQuery

	*****************/

	$.fn.mktablefloat = function (options) {
		this.each(function () {
			var $el = $(this);
			$el.data('mk-tablefloat', $el.data('mk-tablefloat') || new TableFloat(this, options));
		});
	}

}(jQuery);


// WEBPACK FOOTER //
// ./src/shared/utils/table-float.js